import { apiClient } from "./client";
import type { CfoAssessmentRead, CfoConfigurationUpdate, CfoReevaluationRequest, CfoScoreExplanation, CfoWorkRead, EffectiveScoring } from "./types";
const base = (slug: string) => `/projects/${slug}/cfo-workflow`;
export async function updateCfoConfiguration(slug: string, request: CfoConfigurationUpdate): Promise<EffectiveScoring> {
  return (await apiClient.patch<EffectiveScoring>(`${base(slug)}/configuration`, request)).data;
}
export async function getCfoAssessment(slug: string, companyId: number): Promise<CfoAssessmentRead> {
  return (await apiClient.get<CfoAssessmentRead>(`${base(slug)}/companies/${companyId}/assessments/current`)).data;
}
export async function requestCfoEvaluation(slug: string, companyId: number, request: CfoReevaluationRequest): Promise<CfoWorkRead> {
  return (await apiClient.post<CfoWorkRead>(`${base(slug)}/companies/${companyId}/reevaluate`, request)).data;
}
export async function getCfoScoreExplanation(slug: string, companyId: number): Promise<CfoScoreExplanation> {
  return (await apiClient.get<CfoScoreExplanation>(`${base(slug)}/companies/${companyId}/score-explanation`)).data;
}
